import Vue from 'vue'
import VueRouter from 'vue-router'
import About from "../views/About";
import Contacts from "../views/Contacts";
import Projects from "../views/Projects";
import ProjectViewer from "../views/ProjectsViewer";
import store from "../store"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: ProjectViewer,
        meta: {setScroll: true, scrollId: 'viewer'},
        props: (route) => ({
            'images': store.getters.getFeaturedProjects
        })
    }, {
        path: '/about',
        name: 'about',
        component: About,
    }, {
        path: '/projects/:category?',
        name: 'projects',
        component: Projects,
        meta: {setScroll: true},
    }, {
        path: '/contacts',
        name: 'contacts',
        component: Contacts,
    }, {
        path: '/project/:project_name',
        name: 'project',
        component: ProjectViewer,
        props: (route) => ({
            'project': store.getters.getActiveProject(route.params.project_name),
            'images': store.getters.getImagesByProject(route.params.project_name),
            'from_path': router
        })
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        // return new Promise((resolve, reject) => {
        //   setTimeout(() => {
        //     resolve( savedPosition || { x: 0, y: 0 } )
        //   }, 600)
        // })
    },
    routes
})

router.beforeEach((to, from, next) => {
    store.state.setScroll = false;
    //save position
    if (from.meta.setScroll) {
        let scrollElement = from.meta.scrollId ? document.getElementById(from.meta.scrollId) : document.scrollingElement;
        store.state.savedPositions[from.path + '_scroll'] = scrollElement.scrollTop;
    }

    next()
})
export default router
